module.exports = __webpack_public_path__ + "img/id-menu-sel-2.42a7eb4c.svg";